import {
    Button,
    Card,
    CardActions,
    CardContent,
    Grid,
    Typography,
    Box,
} from "@mui/material";
import { Link } from "react-router-dom";

type CompetitorCardProps = {
    image: string;
    title: string;
    description: string;
    link: string;
    buttonText: string;
    onClick: () => void;
};

export const CompetitorCard = ({
    image,
    title,
    description,
    link,
    buttonText,
    onClick,
}: CompetitorCardProps) => {
    const isDisabled = title === "NL Reports";

    return (
        <Grid item>
            <Box sx={{ position: "relative", display: "inline-block" }}>
                <Card
                    elevation={8}
                    sx={{
                        borderRadius: "1.5rem",
                        maxWidth: "220px",
                        maxHeight: "420px",
                        filter: isDisabled ? "blur(2px)" : "none",
                        pointerEvents: isDisabled ? "none" : "auto",
                        opacity: isDisabled ? 0.8 : 1,
                        transition: "filter 0.3s, opacity 0.3s",
                    }}
                >
                    <CardContent sx={{ padding: "1.25rem", paddingBottom: 0 }}>
                        <Typography
                            gutterBottom
                            variant="h6"
                            fontWeight={700}
                            fontSize={14}
                            textAlign="center"
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="#4d4848"
                            fontWeight={400}
                            textAlign="center"
                            fontSize={12}
                        >
                            {description}
                        </Typography>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <img
                                src={image}
                                alt={title}
                                height="180"
                                style={{ width: "80%", margin: "auto" }}
                            />
                        </div>
                    </CardContent>

                    <CardActions
                        sx={{
                            padding: "0.5rem 1rem 1rem",
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                        }}
                    >
                        <Link
                            to={link}
                            onClick={isDisabled ? undefined : onClick}
                            style={{
                                textDecoration: "none",
                                pointerEvents: isDisabled ? "none" : "auto",
                            }}
                        >
                            <Button
                                sx={{
                                    color: "#171515",
                                    borderRadius: "3.75rem",
                                    border: "0.125rem solid #171515",
                                    fontSize: "0.8rem",
                                    padding: "0.25rem 1.5rem",
                                    "&:hover": {
                                        color: "white",
                                        backgroundColor: "#171515",
                                    },
                                }}
                                disabled={isDisabled}
                            >
                                {buttonText}
                            </Button>
                        </Link>
                    </CardActions>
                </Card>

                {isDisabled && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "rgba(0, 0, 0, 0.2)",
                            borderRadius: "1.5rem",
                            color: "white",
                            fontWeight: "bold",
                            fontSize: "1rem",
                            zIndex: 1,
                        }}
                    >
                        Coming Soon
                    </Box>
                )}
            </Box>
        </Grid>
    );
};
